/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper,
  IconButton, TablePagination, Tooltip, Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { formatUtcForDisplay } from '../utils/dateTime';

function AcessoList({ refresh, onEdit, onAcessoDeleted, entradaStart, entradaEnd, imovelId, pessoaId }) {
  const { user } = useAuth();
  const [acessos, setAcessos] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchAcessos = () => {
    let apiUrl = `/acessos?page=${page}&limit=${rowsPerPage}`;

    if (entradaStart) apiUrl += `&entradaStart=${entradaStart}`;
    if (entradaEnd) apiUrl += `&entradaEnd=${entradaEnd}`;
    if (imovelId) apiUrl += `&imovelId=${imovelId}`;
    if (pessoaId) apiUrl += `&pessoaId=${pessoaId}`;

    api.get(apiUrl)
      .then((response) => {
        setAcessos(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => {
        console.error('Erro ao buscar acessos:', error);
      });
  };

  useEffect(() => {
    fetchAcessos();
  }, [refresh, page, rowsPerPage, entradaStart, entradaEnd, imovelId, pessoaId]);

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja deletar este acesso?')) {
      try {
        await api.delete(`/acessos/${id}`);
        onAcessoDeleted();
        fetchAcessos();
      } catch (error) {
        console.error('Erro ao deletar acesso:', error);
      }
    }
  };

  const handleMarcarSaida = async (acessoId) => {
    if (window.confirm('Tem certeza que deseja marcar a saida para este acesso?')) {
      try {
        const saidaData = {
          setSaidaNow: true,
          funcionario_saida_id: user.pessoa_id,
        };
        await api.put(`/acessos/${acessoId}`, saidaData);
        fetchAcessos();
      } catch (error) {
        console.error('Erro ao registrar saida:', error);
      }
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="acessos table">
          <TableHead>
            <TableRow>
              {(user && user.tipo_usuario === 'admin') && <TableCell>Empresa ID</TableCell>}
              <TableCell>Residencia</TableCell>
              <TableCell>Visitante</TableCell>
              <TableCell>Veiculo ID</TableCell>
              <TableCell>Entrada</TableCell>
              <TableCell>Saida</TableCell>
              <TableCell>Acoes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {acessos.map((acesso) => (
              <TableRow key={acesso.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} hover>
                {(user && user.tipo_usuario === 'admin') && <TableCell>{acesso.empresa_id}</TableCell>}
                <TableCell>{acesso.imovel_numero ? `Unid. ${acesso.imovel_numero}` : 'N/A'}</TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    {acesso.pessoa_nome || 'N/A'}
                    {acesso.acesso_liberado_id && (
                      <Tooltip title="Acesso Liberado">
                        <VerifiedUserIcon fontSize="small" color="success" />
                      </Tooltip>
                    )}
                  </Box>
                </TableCell>
                <TableCell>{acesso.veiculo_id || 'N/A'}</TableCell>
                <TableCell>{formatUtcForDisplay(acesso.entrada, user)}</TableCell>
                <TableCell>{formatUtcForDisplay(acesso.saida, user)}</TableCell>
                <TableCell>
                  {!acesso.saida && (
                    <IconButton aria-label="marcar saida" onClick={() => handleMarcarSaida(acesso.id)}>
                      <ExitToAppIcon />
                    </IconButton>
                  )}
                  <IconButton aria-label="edit" onClick={() => onEdit(acesso)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(acesso.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Linhas por pagina:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default AcessoList;
